import { useAppDispatch } from "@redux";
import { 
  createMessage as createMessageAction,
  updateMessage as updateMessageAction, 
  deleteMessage as deleteMessageAction,
  requestFileUrl as requestFileUrlAction
} from "@redux";

export const useMessageOperations = () => {
  const dispatch = useAppDispatch();

  const createMessage = ({ reservation_id, temp_reservation_id, content, file_url }: { 
    reservation_id: number | null, 
    temp_reservation_id?: number,
    content?: string, 
    file_url?: string 
  }) => {
    return dispatch(createMessageAction({
      reservation_id: reservation_id,
      temp_reservation_id: temp_reservation_id,
      content,
      file_url: file_url
    }));
  };

  const updateMessage = ({ id, content, fileUrl }: { 
    id: number, 
    content?: string, 
    fileUrl?: string 
  }) => {
    return dispatch(updateMessageAction({
      id,
      content,
      file_url: fileUrl
    }));
  };

  const deleteMessage = (id: number) => {
    return dispatch(deleteMessageAction(id));
  };

  const requestFileUrl = (params: { filename: string, file_type: string, acl: string }) => {
    return dispatch(requestFileUrlAction(params));
  };

  return { createMessage, updateMessage, deleteMessage, requestFileUrl };
};
